import { useMemo } from 'react';

import { ProductCardV3Props } from '~/components/ProductCardV3/types';
import ProductCardC from '~/components/ProductCardV3/variants/ProductCardC/ProductCardC';
import ProductCardHorizontal from '~/components/ProductCardV3/variants/ProductCardHorizontal/ProductCardHorizontal';
import ProductCardL from '~/components/ProductCardV3/variants/ProductCardL/ProductCardL';
import ProductCardM from '~/components/ProductCardV3/variants/ProductCardM/ProductCardM';
import ProductCardS from '~/components/ProductCardV3/variants/ProductCardS/ProductCardS';
import ProductCardXL from '~/components/ProductCardV3/variants/ProductCardXL/ProductCardXL';
import ProductCardXS from '~/components/ProductCardV3/variants/ProductCardXS/ProductCardXS';

/**
 * ProductCardV3Factory - Factory component that renders appropriate card variant
 * based on the `variant` prop (m, s, xs, c or horizontal)
 */
const ProductCardV3Factory = ({
  variant = 'm',
  ...props
}: ProductCardV3Props) => {
  const CardComponent = useMemo(() => {
    switch (variant) {
      case 'xl':
        return ProductCardXL;
      case 'l':
        return ProductCardL;
      case 'm':
        return ProductCardM;
      case 's':
        return ProductCardS;
      case 'xs':
        return ProductCardXS;
      case 'c':
        return ProductCardC;
      case 'horizontal':
        return ProductCardHorizontal;
      default:
        return ProductCardM;
    }
  }, [variant]);

  return <CardComponent {...props} />;
};

export default ProductCardV3Factory;
